import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";

var root = $.from_html(`<div class="slex-heading-eyebrow"> </div>`);
var root_1 = $.from_html(`<div class="slex-heading-meta"> </div>`);
var root_2 = $.from_html(`<p class="slex-heading-subtitle"> </p>`);
var root_3 = $.from_html(`<div class="slex-heading"><!> <!> <!> <!></div>`);

export default function Heading($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	const levels = new Set([1, 2, 3, 4, 5, 6]);

	function tag() {
		return `h${levels.has(Number($.get(p).level)) ? Number($.get(p).level) : 2}`;
	}

	var div = root_3();
	var node = $.child(div);

	{
		var consequent = ($$anchor) => {
			var div_1 = root();
			var text_1 = $.child(div_1, true);

			$.reset(div_1);
			$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).eyebrow)]);
			$.append($$anchor, div_1);
		};

		$.if(node, ($$render) => {
			if ($.get(p).eyebrow) $$render(consequent);
		});
	}

	var node_1 = $.sibling(node, 2);

	$.element(node_1, tag, false, ($$element, $$anchor) => {
		$.set_class($$element, 0, 'slex-heading-title');

		var text_2 = $.text();

		$.template_effect(($0) => $.set_text(text_2, $0), [
			() => text($.get(p).title ?? $.get(p).text ?? $.get(p).content ?? $.get(p).label ?? $$props.componentName)
		]);

		$.append($$anchor, text_2);
	});

	var node_2 = $.sibling(node_1, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_2 = root_1();
			var text_3 = $.child(div_2, true);

			$.reset(div_2);
			$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(p).meta)]);
			$.append($$anchor, div_2);
		};

		$.if(node_2, ($$render) => {
			if ($.get(p).meta) $$render(consequent_1);
		});
	}

	var node_3 = $.sibling(node_2, 2);

	{
		var consequent_2 = ($$anchor) => {
			var p_1 = root_2();
			var text_4 = $.child(p_1, true);

			$.reset(p_1);
			$.template_effect(($0) => $.set_text(text_4, $0), [() => text($.get(p).subtitle)]);
			$.append($$anchor, p_1);
		};

		$.if(node_3, ($$render) => {
			if ($.get(p).subtitle) $$render(consequent_2);
		});
	}

	$.reset(div);
	$.template_effect(($0) => $.set_attribute(div, 'data-level', $0), [() => text($.get(p).level ?? 2)]);
	$.append($$anchor, div);
	$.pop();
}